import * as types from '../actionTypes/voucherPaymentsBasket.actionTypes';

export const setCurrentBasketUUID = payload => ({
  type: types.VOUCHER_PAYMENTS_BASKET.SET_CURRENT_BASKET_UUID,
  payload
});
